import VerticalTemplateOneOneZero from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneZero";
import VerticalTemplateOneOneOne from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneOne";
import HorizontalTemplateOneOneZero from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneZero";
import CenteredTemplateOneOneZero from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneZero";
import HorizontalTemplateOneOneOne from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneOne";
import CenteredTemplateOneTwoZero from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneOne";
import VerticalTemplateOneOneTwo from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneTwo";
import VerticalTemplateOneOneThree from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneThree";
import HorizontalTemplateOneOneTwo from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneTwo";
import HorizontalTemplateOneOneThree from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneThree";
import CenteredTemplateOneOneTwo from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneTwo";
import CenteredTemplateOneOneThree from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneThree";
import VerticalTemplateFiveButtons from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateFiveButtons";
import HorizontalTemplateFiveButtons from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateFiveButtons";
import VerticalTemplateOneOneFour from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneFour";
import HorizontalTemplateOneOneFour from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneFour";
import CenteredTemplateOneOneFour from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneFour";
import VerticalTemplateOneOneFive from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneFive";
import HorizontalTemplateOneOneFive from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneFive";
import CenteredTemplateOneOneFive from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneFive";
import VerticalTemplateOneOneSix from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneSix";
import HorizontalTemplateOneOneSix from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneSix";
import CenteredTemplateOneOneSix from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneSix";
import VerticalTemplateOneOneSeven from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneSeven";
import HorizontalTemplateOneOneSeven from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneSeven";
import CenteredTemplateOneOneSeven from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneSeven";
import VerticalTemplateOneOneEight from "../components/user-portal/pages/elemets/verticalBanner/VerticalTemplateOneOneEight";
import HorizontalTemplateOneOneEight from "../components/user-portal/pages/elemets/horizontalBanner/HorizontalTemplateOneOneEight";
import CenteredTemplateOneOneEight from "../components/user-portal/pages/elemets/centeredBanner/CenteredTemplateOneOneEight";
import PrompterTemplate from "../components/user-portal/pages/elemets/prompter/PrompterTemplate";

export const VerticalTemplates = {
  "vertical-110": {
    type: "vertical",
    label: "Vertical 110",
    preview: VerticalTemplateOneOneZero,
    previewImage: "/cta-v-110.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "Make \n Your \n Next \n Move",
      titleFont: "Helvetica",
      titleFontSize: "48",
      titleColor: "#605E4D",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleLetterSpacing: "-2px",

      subtitleText: "A quick action to \n keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#E8DCC8",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: true,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#D8D8D8",
      buttonBackgroundColor: "#599E10",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-110"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-110");

      return formData;
    },
  },
  "vertical-111": {
    type: "vertical",
    label: "Vertical 111",
    preview: VerticalTemplateOneOneOne,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "background",
      "button",
      "secondaryButton",
      "placement",
    ],
    defaultValues: {
      titleText: "Choose Your Path",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: false,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Pick what fits your \n goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,
      subtitleBackgroundColor: "#000000",

      backgroundType: "color",
      backgroundColor: "#848484",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#159DAF",

      // Secondary Button (Get Started)
      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "18",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#E83605",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-111"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-111");

      return formData;
    },
  },
  "vertical-112": {
    type: "vertical",
    label: "Vertical 112",
    preview: VerticalTemplateOneOneTwo,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "contentImageOne",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "THE BEST PRODUCT IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "34",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleLetterSpacing: "-2px",

      subtitleText: "And it's yours today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "16",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#3D4F46",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#14B14B",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-112"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-112");

      return formData;
    },
  },
  "vertical-113": {
    type: "vertical",
    label: "Vertical 113",
    preview: VerticalTemplateOneOneThree,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "contentImageOne",
      "secondarySubtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "Complete \n Growth Bundle",
      titleFont: "Helvetica",
      titleFontSize: "24",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: false,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Course access \n mentoring\n  templates",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      secondarySubtitleText: "Save 25% today.",
      secondarySubtitleFont: "Helvetica",
      secondarySubtitleFontSize: "28",
      secondarySubtitleColor: "#FFFFFF",
      secondarySubtitleTextAlign: "center",
      secondarySubtitleIsBold: false,
      secondarySubtitleIsItalic: false,
      secondarySubtitleIsUnderline: false,

      contentImageOne: "/growth.png",

      backgroundType: "color",
      backgroundColor: "#8B88D8",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#D8D8D8",
      buttonBackgroundColor: "#54157C",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-113"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-113");

      return formData;
    },
  },
  "vertical-five-buttons": {
    type: "vertical",
    label: "Vertical five buttons",
    preview: VerticalTemplateFiveButtons,
    previewImage: "/cta-v-111.png",
    steps: ["fiveButtons", "placement"],
    defaultValues: {
      backgroundType: "color",
      backgroundColor: "#3B0F4A",
      backgroundImage: null,

      // Button 1
      button1Label: "Websites",
      button1Link: "",
      button1Font: "Helvetica",
      button1FontSize: "18",
      button1FontColor: "#000000",
      button1BackgroundColor: "#EBC85B",
      button1IsBold: false,
      button1IsItalic: false,
      button1IsUnderline: false,

      // Button 2
      button2Label: "Demo Page",
      button2Link: "",
      button2Font: "Helvetica",
      button2FontSize: "18",
      button2FontColor: "#000000",
      button2BackgroundColor: "#F4A261",
      button2IsBold: false,
      button2IsItalic: false,
      button2IsUnderline: false,

      // Button 3
      button3Label: "Knowledge Base",
      button3Link: "",
      button3Font: "Helvetica",
      button3FontSize: "18",
      button3FontColor: "#000000",
      button3BackgroundColor: "#F0805A",
      button3IsBold: false,
      button3IsItalic: false,
      button3IsUnderline: false,

      // Button 4
      button4Label: "Newsletter Signup",
      button4Link: "",
      button4Font: "Helvetica",
      button4FontSize: "18",
      button4FontColor: "#000000",
      button4BackgroundColor: "#E04646",
      button4IsBold: false,
      button4IsItalic: false,
      button4IsUnderline: false,

      // Button 5
      button5Label: "Book a Call",
      button5Link: "",
      button5Font: "Helvetica",
      button5FontSize: "18",
      button5FontColor: "#000000",
      button5BackgroundColor: "#C62828",
      button5IsBold: false,
      button5IsItalic: false,
      button5IsUnderline: false,

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-five-buttons"]
        .defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-five-buttons");

      return formData;
    },
  },
  "horizontal-110": {
    type: "horizontal",
    label: "Horizontal 110",
    preview: HorizontalTemplateOneOneZero,
    previewImage: "/cta-h-110.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "Make Your Next Move",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#605E4D",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,
      titleLetterSpacing: "-2px",

      subtitleText: "A quick action to \n keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "13",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#E8DCC8",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#599E10",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-110"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-110");

      return formData;
    },
  },
  "horizontal-111": {
    type: "horizontal",
    label: "Horizontal 111",
    preview: HorizontalTemplateOneOneOne,
    previewImage: "/cta-h-110.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "Choose Your Path",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,

      subtitleText: "Pick what fits your \n goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#5E5D60",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#FF5722",

      // Secondary Button (Get Started)
      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "16",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#00BCD4",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-111"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-111");

      return formData;
    },
  },
  "horizontal-112": {
    type: "horizontal",
    label: "Horizontal 112",
    preview: HorizontalTemplateOneOneTwo,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "contentImageOne",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "THE BEST PRODUCT IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,
      titleLetterSpacing: "-2px",

      subtitleText: "And it's yours today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#3D4F46",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "14",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#14B14B",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-112"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-112");

      return formData;
    },
  },
  "horizontal-113": {
    type: "horizontal",
    label: "Horizontal 113",
    preview: HorizontalTemplateOneOneThree,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "contentImageOne",
      "secondarySubtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "Complete \n Growth Bundle",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Course access \n mentoring\n  templates",
      subtitleFont: "Helvetica",
      subtitleFontSize: "14",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      secondarySubtitleText: "Save 25% today.",
      secondarySubtitleFont: "Poppins",
      secondarySubtitleFontSize: "24",
      secondarySubtitleColor: "#FFFFFF",
      secondarySubtitleTextAlign: "center",
      secondarySubtitleIsBold: true,
      secondarySubtitleIsItalic: false,
      secondarySubtitleIsUnderline: false,

      contentImageOne: "/growth.png",

      backgroundType: "color",
      backgroundColor: "#8B88D8",
      backgroundImage: null,

      buttonLabel: "Start Today",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "15",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#54157C",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-113"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-113");

      return formData;
    },
  },
  "horizontal-five-buttons": {
    type: "horizontal",
    label: "Horizontal five buttons",
    preview: HorizontalTemplateFiveButtons,
    previewImage: "/cta-v-111.png",
    steps: ["fiveButtons", "placement"],
    defaultValues: {
      backgroundType: "color",
      backgroundColor: "#3B0F4A",
      backgroundImage: null,

      // Button 1
      button1Label: "Website",
      button1Link: "",
      button1Font: "Helvetica",
      button1FontSize: "18",
      button1FontColor: "#000000",
      button1BackgroundColor: "#EBC85B",
      button1IsBold: false,
      button1IsItalic: false,
      button1IsUnderline: false,

      // Button 2
      button2Label: "Demo Page",
      button2Link: "",
      button2Font: "Helvetica",
      button2FontSize: "18",
      button2FontColor: "#000000",
      button2BackgroundColor: "#F4A261",
      button2IsBold: false,
      button2IsItalic: false,
      button2IsUnderline: false,

      // Button 3
      button3Label: "Knowledge Base",
      button3Link: "",
      button3Font: "Helvetica",
      button3FontSize: "18",
      button3FontColor: "#000000",
      button3BackgroundColor: "#F0805A",
      button3IsBold: false,
      button3IsItalic: false,
      button3IsUnderline: false,

      // Button 4
      button4Label: "Newsletter Signup",
      button4Link: "",
      button4Font: "Helvetica",
      button4FontSize: "18",
      button4FontColor: "#000000",
      button4BackgroundColor: "#E04646",
      button4IsBold: false,
      button4IsItalic: false,
      button4IsUnderline: false,

      // Button 5
      button5Label: "Book a Call",
      button5Link: "",
      button5Font: "Helvetica",
      button5FontSize: "18",
      button5FontColor: "#000000",
      button5BackgroundColor: "#C62828",
      button5IsBold: false,
      button5IsItalic: false,
      button5IsUnderline: false,

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-five-buttons"]
        .defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-five-buttons");

      return formData;
    },
  },
  "centered-110": {
    type: "centered",
    label: "Centered 110",
    preview: CenteredTemplateOneOneZero,
    previewImage: "/cta-c-110.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "Make Your Next Move",
      titleFont: "Helvetica",
      titleFontSize: "34",
      titleColor: "#605E4D",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,
      titleLetterSpacing: "-2px",

      subtitleText: "A quick action to \n keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "24",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#E8DCC8",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#599E10",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-110"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-110");

      return formData;
    },
  },
  "centered-120": {
    type: "centered",
    label: "Centered 120",
    preview: CenteredTemplateOneTwoZero,
    previewImage: "/cta-c-110.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "Choose Your Path",
      titleFont: "Helvetica",
      titleFontSize: "28",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Pick what fits your \n goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "24",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,
      subtitleBackgroundColor: "#000000",

      backgroundType: "color",
      backgroundColor: "#5E5D60",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#0D99FF",

      // Secondary Button (Get Started)
      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "16",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#E83605",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-120"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-120");

      return formData;
    },
  },
  "centered-112": {
    type: "centered",
    label: "Centered 112",
    preview: CenteredTemplateOneOneTwo,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "subtitle",
      "contentImageOne",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "THE BEST PRODUCT \n IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "34",
      titleColor: "#fff",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,
      titleLetterSpacing: "-2px",

      subtitleText: "And it's yours \n today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "16",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#343F37",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#599E10",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-112"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-112");

      return formData;
    },
  },
  "centered-113": {
    type: "centered",
    label: "Centered 113",
    preview: CenteredTemplateOneOneThree,
    previewImage: "/cta-v-111.png",
    steps: [
      "title",
      "secondaryTitle",
      "contentImageOne",
      "subtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      titleText: "Complete Growth Bundle",
      titleFont: "Montserrat",
      titleFontSize: "31",
      titleColor: "#54157C",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      secondaryTitleText: "Course access\nMentoring\nTemplates",
      secondaryTitleFont: "Montserrat",
      secondaryTitleFontSize: "25",
      secondaryTitleColor: "#485299",
      secondaryTitleTextAlign: "center",
      secondaryTitleIsBold: true,
      secondaryTitleIsItalic: false,
      secondaryTitleIsUnderline: false,

      subtitleText: "Save 25% today.",
      subtitleFont: "Montserrat",
      subtitleFontSize: "19",
      subtitleColor: "#FEF7EC",
      subtitleTextAlign: "center",
      subtitleIsBold: true,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/growth.png",

      backgroundType: "color",
      backgroundColor: "#7C82C8",
      backgroundImage: null,

      buttonLabel: "Start Today",
      buttonFont: "Poppins",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "19",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#54157C",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-113"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-113");

      return formData;
    },
  },
  "vertical-114": {
    type: "vertical",
    label: "Vertical 114",
    preview: VerticalTemplateOneOneFour,
    previewImage: "/cta-v-114.png",
    steps: [
      "title",
      "subtitle",
      "background",
      "button",
      "secondaryButton",
      "placement",
    ],
    defaultValues: {
      titleText: "Choose your path",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#FFFFFF",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Pick what fits your goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,
      subtitleBackgroundColor: "#000000",

      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/oneoneFourbg.png",

      buttonLabel: "Get Started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#00CED1",

      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "18",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#FF4500",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-114"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-114");

      return formData;
    },
  },
  "horizontal-114": {
    type: "horizontal",
    label: "Horizontal 114",
    preview: HorizontalTemplateOneOneFour,
    previewImage: "/cta-h-114.png",
    steps: [
      "title",
      "subtitle",
      "background",
      "button",
      "secondaryButton",
      "placement",
    ],
    defaultValues: {
      titleText: "Choose your path",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#FFFFFF",
      titleTextAlign: "left",
      titleIsBold: false,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: false,

      subtitleText: "Pick what fits your goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,
      subtitleBackgroundColor: "#000000",

      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/oneoneFourbg.png",

      buttonLabel: "Get Started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#00CED1",

      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "16",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#FF4500",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-114"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-114");

      return formData;
    },
  },
  "centered-114": {
    type: "centered",
    label: "Centered 114",
    preview: CenteredTemplateOneOneFour,
    previewImage: "/cta-c-114.png",
    steps: [
      "title",
      "subtitle",
      "background",
      "button",
      "secondaryButton",
      "placement",
    ],
    defaultValues: {
      titleText: "Choose your path",
      titleFont: "Helvetica",
      titleFontSize: "34",
      titleColor: "#FFFFFF",
      titleTextAlign: "center",
      titleIsBold: false,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: false,

      subtitleText: "Pick what fits your goal today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "24",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,
      subtitleBackgroundColor: "#000000",

      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/oneoneFourbg.png",

      buttonLabel: "Get Started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#00CED1",

      secondaryButtonLabel: "Learn more",
      secondaryButtonFont: "Helvetica",
      secondaryButtonIsBold: false,
      secondaryButtonIsItalic: false,
      secondaryButtonIsUnderline: false,
      secondaryButtonLink: "",
      secondaryButtonFontSize: "18",
      secondaryButtonFontColor: "#FFFFFF",
      secondaryButtonBackgroundColor: "#FF4500",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-114"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-114");

      return formData;
    },
  },
  "vertical-115": {
    type: "vertical",
    label: "Vertical 115",
    preview: VerticalTemplateOneOneFive,
    previewImage: "/cta-v-114.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "ONE OF\nA KIND",
      titleFont: "Helvetica",
      titleFontSize: "42",
      titleColor: "#E6E7EB",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "Two reasons to buy it",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#0B0F14",
      backgroundImage: null,

      buttonLabel: "More Info",
      buttonFont: "Helvetica",
      buttonIsBold: true,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#C03BFF",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-115"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-115");

      return formData;
    },
  },
  "horizontal-115": {
    type: "horizontal",
    label: "Horizontal 115",
    preview: HorizontalTemplateOneOneFive,
    previewImage: "/cta-h-114.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "ONE OF\nA KIND",
      titleFont: "Helvetica",
      titleFontSize: "42",
      titleColor: "#E6E7EB",
      titleTextAlign: "left",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: false,

      subtitleText: "Two reasons to buy it",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#0B0F14",
      backgroundImage: null,

      buttonLabel: "More Info",
      buttonFont: "Helvetica",
      buttonIsBold: true,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#C03BFF",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-115"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-115");

      return formData;
    },
  },
  "centered-115": {
    type: "centered",
    label: "Centered 115",
    preview: CenteredTemplateOneOneFive,
    previewImage: "/cta-c-114.png",
    steps: ["title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      titleText: "ONE OF\nA KIND",
      titleFont: "Helvetica",
      titleFontSize: "42",
      titleColor: "#E6E7EB",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: false,

      subtitleText: "Two reasons to buy it",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#0B0F14",
      backgroundImage: null,

      buttonLabel: "More Info",
      buttonFont: "Helvetica",
      buttonIsBold: true,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#C03BFF",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-115"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-115");

      return formData;
    },
  },
  "vertical-116": {
    type: "vertical",
    label: "Vertical 116",
    preview: VerticalTemplateOneOneSix,
    previewImage: "/cta-v-116.png",
    steps: ["logo", "title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "MAKE YOUR NEXT MOVE",
      titleFont: "Helvetica",
      titleFontSize: "42",
      titleColor: "#E91E63",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "A quick action to keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#1A2B8C",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#E91E63",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-116"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-116");

      return formData;
    },
  },
  "horizontal-116": {
    type: "horizontal",
    label: "Horizontal 116",
    preview: HorizontalTemplateOneOneSix,
    previewImage: "/cta-h-116.png",
    steps: ["logo", "title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "MAKE YOUR NEXT MOVE",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#E91E63",
      titleTextAlign: "left",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,

      subtitleText: "A quick action to keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "16",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "left",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#1A2B8C",
      backgroundImage: null,

      buttonLabel: "I want it!",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#E91E63",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-116"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-116");

      return formData;
    },
  },
  "centered-116": {
    type: "centered",
    label: "Centered 116",
    preview: CenteredTemplateOneOneSix,
    previewImage: "/cta-c-116.png",
    steps: ["logo", "title", "subtitle", "background", "button", "placement"],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "MAKE YOUR NEXT MOVE",
      titleFont: "Helvetica",
      titleFontSize: "56",
      titleColor: "#E91E63",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,

      subtitleText: "A quick action to keep momentum.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "20",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      backgroundType: "color",
      backgroundColor: "#1A2B8C",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#E91E63",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-116"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-116");

      return formData;
    },
  },
  "vertical-117": {
    type: "vertical",
    label: "Vertical 117",
    preview: VerticalTemplateOneOneSeven,
    previewImage: "/cta-v-117.png",
    steps: [
      "logo",
      "title",
      "contentImageOne",
      "subtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "THE BEST PRODUCT IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "26",
      titleColor: "#FFFFFF",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,

      subtitleText: "And it's yours today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "16",
      subtitleColor: "#FFFFFF",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#2F4F4F",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#6B8E23",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-117"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-117");

      return formData;
    },
  },
  "horizontal-117": {
    type: "horizontal",
    label: "Horizontal 117",
    preview: HorizontalTemplateOneOneSeven,
    previewImage: "/cta-h-117.png",
    steps: [
      "logo",
      "title",
      "contentImageOne",
      "subtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "THE BEST PRODUCT IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "22",
      titleColor: "#32CD32",
      titleTextAlign: "left",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,

      subtitleText: "And it's yours today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "16",
      subtitleColor: "#90EE90",
      subtitleTextAlign: "left",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#2F4F4F",
      backgroundImage: null,

      buttonLabel: "I want it!",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#32CD32",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-117"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-117");

      return formData;
    },
  },
  "centered-117": {
    type: "centered",
    label: "Centered 117",
    preview: CenteredTemplateOneOneSeven,
    previewImage: "/cta-c-117.png",
    steps: [
      "logo",
      "title",
      "contentImageOne",
      "subtitle",
      "background",
      "button",
      "placement",
    ],
    defaultValues: {
      logoImage: "/yourLogo.svg",
      logoImagePreview: null,

      titleText: "THE BEST PRODUCT IS HERE",
      titleFont: "Helvetica",
      titleFontSize: "34",
      titleColor: "#00FF36",
      titleTextAlign: "center",
      titleIsBold: true,
      titleIsItalic: false,
      titleIsUnderline: false,
      titleUppercase: true,

      subtitleText: "And it's yours today.",
      subtitleFont: "Helvetica",
      subtitleFontSize: "18",
      subtitleColor: "#90EE90",
      subtitleTextAlign: "center",
      subtitleIsBold: false,
      subtitleIsItalic: false,
      subtitleIsUnderline: false,

      contentImageOne: "/mug.png",

      backgroundType: "color",
      backgroundColor: "#2F4F4F",
      backgroundImage: null,

      buttonLabel: "Get started",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#599E10",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-117"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-117");

      return formData;
    },
  },
  "vertical-118": {
    type: "vertical",
    label: "Vertical 118",
    preview: VerticalTemplateOneOneEight,
    previewImage: "/cta-v-118.png",
    steps: ["background", "button", "placement"],
    defaultValues: {
      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/singleBg.png",

      buttonLabel: "Register Now",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "18",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#32CD32",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["vertical-118"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "vertical-118");

      return formData;
    },
  },
  "horizontal-118": {
    type: "horizontal",
    label: "Horizontal 118",
    preview: HorizontalTemplateOneOneEight,
    previewImage: "/cta-h-118.png",
    steps: ["title", "background", "button", "placement"],
    defaultValues: {
      titleText: "Your Image",
      titleFont: "Brush Script MT",
      titleFontSize: "56",
      titleColor: "#90EE90",
      titleTextAlign: "left",
      titleIsBold: false,
      titleIsItalic: true,
      titleIsUnderline: false,

      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/singleBgHorizontal.png",

      buttonLabel: "Register Now",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "16",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#32CD32",

      placement: "left",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["horizontal-118"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "horizontal-118");

      return formData;
    },
  },
  "centered-118": {
    type: "centered",
    label: "Centered 118",
    preview: CenteredTemplateOneOneEight,
    previewImage: "/cta-c-118.png",
    steps: ["title", "background", "button", "placement"],
    defaultValues: {
      titleText: "Your Image",
      titleFont: "Brush Script MT",
      titleFontSize: "64",
      titleColor: "#90EE90",
      titleTextAlign: "center",
      titleIsBold: false,
      titleIsItalic: true,
      titleIsUnderline: false,

      backgroundType: "image",
      backgroundColor: null,
      backgroundImage: "/singleBg.png",

      buttonLabel: "Register Now",
      buttonFont: "Helvetica",
      buttonIsBold: false,
      buttonIsItalic: false,
      buttonIsUnderline: false,
      buttonLink: "",
      buttonFontSize: "20",
      buttonFontColor: "#FFFFFF",
      buttonBackgroundColor: "#32CD32",

      placement: "center",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["centered-118"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "centered-118");

      return formData;
    },
  },
  prompter: {
    type: "prompter",
    label: "Prompter",
    preview: PrompterTemplate,
    previewImage: "/icons/captions.svg",
    steps: ["text", "font", "style", "save"],
    defaultValues: {
      text: "Type your script here... your changes will instantly appear in the preview.",
      font: "Helvetica",
      fontSize: 23,
      isBold: false,
      isItalic: false,
      textColor: "#000000",
      speed: 0,
      layout: "compact",
      theme: "light",
      elementName: "",
    },
    submitForm: (data) => {
      const formData = new FormData();
      for (const key in VerticalTemplates["prompter"].defaultValues) {
        formData.append(key, data[key]);
      }

      if (data.id) {
        formData.append("id", data.id);
      }
      formData.append("name", data.name);
      formData.append("folderId", data.folderId);
      formData.append("displayStyle", "prompter");

      return formData;
    },
  },
};

export const verticalTemplatesList = Object.keys(VerticalTemplates)
  .filter((key) => key.startsWith("vertical"))
  .map((key) => ({
    key,
    label: VerticalTemplates[key].label,
    preview: VerticalTemplates[key].preview,
    editable: VerticalTemplates[key].editable,
    defaultValues: VerticalTemplates[key].defaultValues,
  }));

export const horizontalTemplatesList = Object.keys(VerticalTemplates)
  .filter((key) => key.startsWith("horizontal"))
  .map((key) => ({
    key,
    label: VerticalTemplates[key].label,
    preview: VerticalTemplates[key].preview,
    editable: VerticalTemplates[key].editable,
    defaultValues: VerticalTemplates[key].defaultValues,
  }));

export const centeredTemplatesList = Object.keys(VerticalTemplates)
  .filter((key) => key.startsWith("centered"))
  .map((key) => ({
    key,
    label: VerticalTemplates[key].label,
    preview: VerticalTemplates[key].preview,
    editable: VerticalTemplates[key].editable,
    defaultValues: VerticalTemplates[key].defaultValues,
  }));
